import { FC } from 'react';
import { NotificationPillProps } from './model';
import { Root } from './styles';

export const NotificationPill: FC<NotificationPillProps> = ({ count }) => (
  <Root>{count >= 100 ? '99+' : count}</Root>
);
